import { api } from './client';
import type { Comment, UserName } from './types';

interface ListCommentsResponse {
  comments?: Comment[];
}

function normalize(c: Comment): Comment {
  return {
    ...c,
    createdAt: c.createdAt ?? c.created_at,
    user_name: c.user_name ?? c.user,
  };
}

export async function listComments(imageId: string): Promise<Comment[]> {
  const data = await api.get<Comment[] | ListCommentsResponse>(
    `/images/${imageId}/comments`,
  );
  const comments = Array.isArray(data) ? data : data.comments ?? [];
  return comments.map(normalize);
}

export interface PostCommentInput {
  text: string;
}

export async function postComment(
  imageId: string,
  input: PostCommentInput,
): Promise<Comment> {
  const data = await api.post<Comment | { comment: Comment }>(
    `/images/${imageId}/comments`,
    input,
  );
  const c = (data && typeof data === 'object' && 'comment' in data
    ? (data as { comment: Comment }).comment
    : (data as Comment));
  return normalize(c);
}

// Hjälpare för UI:t att avgöra avsändarens färgklass.
export function authorOf(comment: Comment): UserName | null {
  const name = comment.user_name ?? comment.user;
  if (name === 'henrik' || name === 'michelle') return name;
  return null;
}
